import store from "@/store";
import HelperFunctions from '@/classes/HelperFunctions';

export default async ( { next, router } ) => {
    if ( !localStorage.getItem( 'auth_token' ) )
        return router.replace( { name: 'admin.login' } ).catch(()=>{});
    
    else if ( !store.getters['user/getUserId'] ) {
        await HelperFunctions.loadUser().then( () => {
            return next();
        } ).catch( () => {
            return router.replace( { name: 'admin.login' } ).catch(()=>{});
        } );
    }
    return next();
}
